import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
    value: { type: Boolean },
    label: null,
    indeterminate: { type: Boolean },
    disabled: { type: Boolean },
    color: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'change', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean
  label?: string
  indeterminate?: boolean
  disabled?: boolean
  color?:string
};





const iconOn = ref<string>("$icon_checkboxOn")
const iconOff = ref<string>("$icon_checkboxOff")
const iconIndeterminate = ref<string>("$icon_checkBoxindeterminate")

const checked = computed({
  get() {
    return props.value
  },
  set(val: boolean) {
    emit("input", val)
    emit("change", val)
  }
})


return { __sfc: true,props, emit, iconOn, iconOff, iconIndeterminate, checked }
}

})